import React from 'react';
import PropTypes from 'prop-types';
import { Button, ControlLabel, FormGroup, Modal, FormControl } from 'react-bootstrap';

import WysiwygEditor from 'components/form/wysiwyg_editor';

class SectionModal extends React.Component {
  static propTypes = {
    customTables: PropTypes.array.isRequired,
    layout: PropTypes.string,
    section: PropTypes.object,
    sectionTypes: PropTypes.array.isRequired,
    shown: PropTypes.bool.isRequired,
    onHide: PropTypes.func.isRequired,
    onSuccess: PropTypes.func.isRequired
  };

  state = {
    section: {}
  };

  componentDidUpdate(prevProps) {
    if (!prevProps.shown && this.props.shown) {
      this.setState({
        section: { ...this.props.section }
      });
    }
  }

  handleEditorChange = (content) => {
    this.setState(({ section }) => ({ section: { ...section, content } }));
  }

  handleChange = (event) => {
    const { name, value } = event.target;
    this.setState((state) => {
      const section = { ...state.section, [name]: value };
      if (value === "custom_table" && section.customFieldSlug == null) {
        section.customFieldSlug = this.props.customTables[0].value;
      }
      return { section };
    });
  };

  saveSection = () => {
    const section = { ...this.state.section };
    if (this.state.section.sectionType !== "custom_table") {
      section.customFieldSlug = null;
    }
    if (!["custom_table", "custom_paragraph"].includes(this.state.section.sectionType)) {
      section.title = null;
      section.content = null;
    }
    if (this.state.section.sectionType !== "custom_button") {
      section.buttonUrl = null;
      section.buttonText = null;
    }
    this.props.onSuccess(section);
  };

  render() {
    return (
      <Modal backdrop={true} keyboard={true} show={this.props.shown} onHide={this.props.onHide}>
        <Modal.Header>
          <h3>{this.renderHeader()}</h3>
        </Modal.Header>
        <Modal.Body>
          <FormGroup>
            <ControlLabel>Section Type</ControlLabel>
            <FormControl
              componentClass="select"
              name="sectionType"
              value={this.state.section.sectionType}
              onChange={this.handleChange}
            >
              {this.renderSectionTypes()}
            </FormControl>
          </FormGroup>
          {this.renderCustomTableInput()}
          {this.renderCustomParagraphInput()}
          {this.renderCustomButtonInput()}
        </Modal.Body>
        <Modal.Footer>
          <Button bsClass="btn btn-cancel" name="btn-cancel" onClick={this.props.onHide}>Cancel</Button>
          <Button bsClass="btn btn-save" name="btn-save" onClick={this.saveSection}>Save Section</Button>
        </Modal.Footer>
      </Modal>
    );
  }

  renderHeader() {
    return this.state.section.id == null ? "New Section" : "Edit Section";
  }

  renderSectionTypes() {
    return this.props.sectionTypes.map((type) => {
      if (type.key === 'custom_table' && this.props.customTables.length === 0) return null;
      if (type.validLayouts && !_.includes(type.validLayouts, this.props.layout)) return null;
      return <option key={type.id} value={type.key}>{type.label}</option>;
    });
  }

  renderCustomTableInput() {
    if (this.state.section.sectionType !== 'custom_table') {
      return null;
    }

    const customTableOptions = this.props.customTables.map(table => (
      <option key={table.key} value={table.value}>{table.label}</option>
    ));

    return (
      <div>
        <FormGroup>
          <ControlLabel>Custom Table</ControlLabel>
          <FormControl
            componentClass="select"
            name="customFieldSlug"
            value={this.state.section.customFieldSlug || this.props.customTables[0].value}
            onChange={this.handleChange}
          >
            {customTableOptions}
          </FormControl>
        </FormGroup>
        <FormGroup>
          <ControlLabel>Title</ControlLabel>
          <FormControl
            name="title"
            type="string"
            value={this.state.section.title || ""}
            onChange={this.handleChange}
          />
        </FormGroup>
        <FormGroup>
          <ControlLabel>Table Subtext</ControlLabel>
          <FormControl
            componentClass="textarea"
            name="content"
            value={this.state.section.content || ""}
            onChange={this.handleChange}
          />
        </FormGroup>
      </div>
    );
  }

  renderCustomParagraphInput() {
    if (this.state.section.sectionType !== 'custom_paragraph') return;

    return (
      <div>
        <FormGroup>
          <ControlLabel>Title</ControlLabel>
          <FormControl
            name="title"
            type="string"
            value={this.state.section.title || ""}
            onChange={this.handleChange}
          />
        </FormGroup>
        <FormGroup>
          <ControlLabel>Paragraph</ControlLabel>
          <WysiwygEditor
            content={this.state.section.content}
            name="content"
            onChange={this.handleEditorChange}
          />
        </FormGroup>
      </div>
    );
  }

  renderCustomButtonInput() {
    if (this.state.section.sectionType !== 'custom_button') return;

    return (
      <div>
        <FormGroup>
          <ControlLabel>Button URL</ControlLabel>
          <FormControl
            name="buttonUrl"
            type="string"
            value={this.state.section.buttonUrl || ""}
            onChange={this.handleChange}
          />
        </FormGroup>
        <FormGroup>
          <ControlLabel>Button Text</ControlLabel>
          <FormControl
            name="buttonText"
            type="string"
            value={this.state.section.buttonText || ""}
            onChange={this.handleChange}
          />
        </FormGroup>
      </div>
    );
  }
}

export default SectionModal;
